module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.helperDuration.hours),
      expression: "helperDuration.hours",
      modifiers: {
        "number": true
      }
    }],
    ref: "days",
    staticClass: "durationInput",
    attrs: {
      "disabled": _vm.disabled,
      "type": "number"
    },
    domProps: {
      "value": (_vm.helperDuration.hours)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helperDuration, "hours", _vm._n($event.target.value))
      }, _vm.durationChanged2],
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$refs.minutes[0].focus()
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "d-inline px-1"
  }, [_vm._v("Hours")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.helperDuration.minutes),
      expression: "helperDuration.minutes",
      modifiers: {
        "number": true
      }
    }],
    ref: "minutes",
    staticClass: "durationInput",
    attrs: {
      "disabled": _vm.disabled,
      "type": "number"
    },
    domProps: {
      "value": (_vm.helperDuration.minutes)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.helperDuration, "minutes", _vm._n($event.target.value))
      }, _vm.durationChanged2],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "d-inline px-1"
  }, [_vm._v("Minutes")])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-14a92188", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-14a92188"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/inventory/products/components/DurationPicker.vue
// module id = 1022
// module chunks = 0